var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { UAM_STYLES } from '../constants';
import { StyledBlockUamGrid, StyledIcon, StyledBlockTitle, StyledBlockUamContentDiv, StyledCloseButton } from './Block.style';
export const Block = (_a) => {
    var { uamType, id, title, shouldShowCloseIcon, children } = _a, props = __rest(_a, ["uamType", "id", "title", "shouldShowCloseIcon", "children"]);
    const handleClose = (event) => {
        event.stopPropagation();
        props.handleClose && props.handleClose();
    };
    let isLarge = title ? true : false;
    return (React.createElement(StyledBlockUamGrid, { id: id, className: "block", container: true, alignItems: "center", wrap: "nowrap", title: title, type: uamType },
        React.createElement(StyledIcon, { className: "block-icon", type: uamType, isLarge: isLarge },
            React.createElement("span", { className: UAM_STYLES.get(uamType).icon })),
        React.createElement(StyledBlockUamContentDiv, null,
            title && React.createElement(StyledBlockTitle, { className: "block-title" }, title),
            children),
        shouldShowCloseIcon && (React.createElement(StyledCloseButton, { className: "block-close", isLarge: isLarge },
            React.createElement("span", { className: "mi-icon-close", onClick: handleClose })))));
};
Block.defaultProps = {
    id: 'uam-block'
};
//# sourceMappingURL=Block.js.map